import React, { useState } from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import ls from 'localstorage-slim';
import { getCurrentLanguageTexts } from "../../../../constants/seasonPassPersonalInfoLangs";
import axios from "../../../../axios-instance";
import { getCustomURLs } from "../../../../helpers/getCustomURLs";
import { toast } from "react-toastify";

export const MySwal = withReactContent(Swal);

export const GiftTicketToEmail = ({ seatLabel, ticketId }) => {
    const txt = getCurrentLanguageTexts();
    const [email, setEmail] = useState('');

    const token = ls.get('member-access-token')

    const moveSeatToEmailHandler = async () => {
        try {
            const { data } = await axios.post(getCustomURLs().API_URL + `/ShareTicket`, {
                ticketId: ticketId,
                accessToken: token,
                email: email,
            });

            toast.success(txt.MoveHoldedSeatModalTxt['successOperation']);
            MySwal.close();
        } catch (error) {
            toast.error(error.response.data)
        }
    };

    return <div className="buy-membership-modal">
        <label>
            {txt.ShareSeatModalTxt['description']}  {seatLabel && `(${seatLabel})`}
        </label>
        <input type="email"
            placeholder={txt.MoveHoldedSeatModalTxt['placeholder']}
            className="modal-input"
            autoFocus
            value={email}
            onChange={e => setEmail(e.target.value)} />

        <section className='swal2-actions'>

            <button className="swal2-cancel swal2-styled"
                onClick={() => MySwal.close()}>
                {txt.generalTxt['cancel']}
            </button>
            <button disabled={email ? undefined : true} className="swal2-confirm swal2-styled"
                onClick={moveSeatToEmailHandler}>
                {txt.generalTxt['save']}
            </button>

        </section>
    </div>;
};
